import React from "react";
import { useApp } from "context";
import { Helpers } from "utils";
import type { Item } from "components/datetime/Calendar";

type Props = {
  item: Item;
  onClick?: (value: any) => void;
};

export const Day = (props: Props) => {
  const { theme } = useApp();

  const { item } = props;

  const handleClick = () => props.onClick && props.onClick(props.item);

  return (
    <div
      className={Helpers.classNames(
        "qh-item",
        item.today && "qh-today",
        item.selected && "qh-selected",
        item.disabled && "qh-disabled"
      )}
      style={{
        color:
          item.selected && !item.today
            ? theme.palette.font.color
            : item.today
            ? theme.color.primary.color
            : "",
        borderColor: item.selected
          ? !item.today
            ? theme.palette.font.color
            : theme.color.primary.color
          : "",
      }}
      onClick={handleClick}
    >
      {item.day}
    </div>
  );
};
